import Card from "components/card";
import { FaStar } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const NftCard = ({
  id,
  title,
  assigned_to,
  status,
  image,
  extra,
  created_at,
}) => {
  const navigate = useNavigate();
  const handleCardClick = () => {
    const role = localStorage.getItem("role");
    if (role === "customer") {
      navigate(`/tickets/${id}`, { state: { fromCustomer: true } });
    } else {
      navigate(`/admin/tickets/${id}`);
    }
  };

  return (
    <>
      <Card
        extra={`flex flex-col w-full h-full !p-4 3xl:p-![18px] bg-white ${extra}`}
      >
        <div className="h-full w-full">
          <div className="relative w-full">
            <img
              src={image}
              className="mb-3 h-full w-full cursor-pointer rounded-xl 3xl:h-full 3xl:w-full"
              alt=""
              // onClick={handleCardClick}
            />
          </div>

          <div className="mb-3 flex flex-col px-1">
            <div className="flex items-center justify-between">
              <p className="text-xl font-bold text-navy-700 dark:text-white">
                {title}
              </p>
              <p className="text-lg font-medium text-black">
                ₹999 <span className="text-gray-600 line-through">₹1999</span>
              </p>
            </div>
            <div className="mb-2 flex items-center justify-end">
              <p className="text-sm font-medium text-black">Per Night</p>
            </div>
            <div className="flex items-center justify-between">
              <p className="text-lg font-medium text-black">Mumbai, India</p>
              <div className="flex gap-2 text-gray-700">
                <FaStar color="yellow" />
                <FaStar color="yellow" />
                <FaStar color="yellow" />
                <FaStar color="yellow" />
                <FaStar />
              </div>
            </div>
          </div>

          <div className="flex items-center justify-between md:flex-col md:items-start lg:flex-row lg:justify-between xl:flex-col 2xl:items-start 3xl:flex-row 3xl:items-center 3xl:justify-between">
            <button
              // onClick={() => handleOpenModal("status")}
              className="linear text-medium w-full rounded-full bg-brand-900 px-3 py-2 text-white transition duration-200 hover:bg-brand-800"
            >
              Book Now
            </button>
          </div>
        </div>
      </Card>
    </>
  );
};

export default NftCard;
